import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class MockApiInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        const endpointUrl = req.url.split('/api/')?.at(1);

        if (endpointUrl == null) {
          throw err;
        }

        return next
          .handle(
            req.clone({
              url: `/assets/api-mocks/${endpointUrl}.json`,
            }),
          )
          .pipe(
            catchError(() => {
              throw err;
            }),
          );
      }),
    );
  }
}
